"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectSchema = void 0;

var SchemaError_1 = __importDefault(require("../Errors/SchemaError"));

var MappingSchema_1 = __importDefault(require("./MappingSchema"));

var ValueSchema_1 = __importDefault(require("./ValueSchema"));

var VectorSchema_1 = __importDefault(require("./VectorSchema"));

function buildObjectSchema(objectID, lookup) {
  var attributes = [];
  var fields = lookup[objectID];

  if (typeof fields === 'undefined') {
    fields = [];
  }

  delete lookup[objectID];

  var _iterator = _createForOfIteratorHelper(fields),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      attributes.push({
        name: field.name,
        value: buildValueSchema(field.type, lookup)
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return new MappingSchema_1.default(attributes);
}

function buildValueSchema(type, lookup) {
  if (type.endsWith('[]')) {
    return new VectorSchema_1.default(buildValueSchema(type.substring(0, type.length - 2), lookup));
  } // not supported by the contract currently


  if (type.startsWith('object{') && type.endsWith('}')) {
    var objectID = parseInt(type.substring(7, type.length - 1), 10);

    if (isNaN(objectID)) {
      throw new SchemaError_1.default("invalid type '".concat(type, "'"));
    }

    return buildObjectSchema(objectID, lookup);
  }

  return new ValueSchema_1.default(type);
}

function ObjectSchema(schema) {
  var objectLookup = {};

  var _iterator2 = _createForOfIteratorHelper(schema),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var schemaObject = _step2.value;
      var objectID = typeof schemaObject.parent === 'undefined' ? 0 : schemaObject.parent;

      if (typeof objectLookup[objectID] === 'undefined') {
        objectLookup[objectID] = [];
      }

      objectLookup[objectID].push(schemaObject);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return buildObjectSchema(0, objectLookup);
}

exports.ObjectSchema = ObjectSchema;